import { Component } from '@angular/core';
import { RouterModule, Routes, Router } from '@angular/router';
@Component({
  selector: 'Dashboard',
  templateUrl: './Dashboard.html',
  styleUrls: ['./Dashboard.css']
})
export class Dashboard {
   public License:boolean;
   public OTP:boolean;
   public Vehicle:boolean;
   public Count:number=1;
constructor(private router: Router){

}
 
}



// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Pages/Dashboard/Dashboard.ts